import {
    Dialog,
    DialogActions,
    DialogActionsProps,
    DialogContent,
    DialogContentProps,
    DialogProps,
    DialogTitle,
    DialogTitleProps,
} from '@mui/material'

import { FC } from 'react'

export const C1Dialog: FC<DialogProps> = (props) => <Dialog {...props} />
export const C1DialogTitle: FC<DialogTitleProps> = (props) => <DialogTitle {...props} />
export const C1DialogContent: FC<DialogContentProps> = (props) => <DialogContent {...props} />
export const C1DialogActions: FC<DialogActionsProps> = (props) => <DialogActions {...props} />
